import { TaxWithholdingValueType } from '@Types'
import { WhenToSendUnion, TransferFrequencyType, TransferRecurrencesType } from '../TransferFrequency/Types'
import { TransferFeesType } from '../TransferFees/types'
import { DistributionReason } from '@Types'

export type DistributionReasonTypes = DistributionReason | ''

export interface ACHTransferValues {
  fromAccount?: string
  fromAccountName?: string
  toAccount?: string
  toAccountName?: string
  transferAmountDisplay: string
  transferAmountRaw: number
  totalBalanceCheckbox: boolean
  distributionReason?: DistributionReasonTypes
  federalTaxWithholdingType?: TaxWithholdingValueType
  federalTaxWithholdingAmountRaw?: number
  federalTaxWithholdingAmountDisplay?: string
  stateTaxWithholdingType?: TaxWithholdingValueType
  stateTaxWithholdingAmountRaw?: number
  stateTaxWithholdingAmountDisplay?: string
  contributionType?: string
  contributionYear?: string
  relationshipId?: string
  transferRecurrence: TransferRecurrencesType
  whenToSend: WhenToSendUnion
  transferScheduledDate: Date | string
  transferFrequency: TransferFrequencyType
  transferStartDate: Date | string
  numberOfTransfers?: number
  fees: TransferFeesType
  optOutFormProvided?: boolean
}

export const PREVIOUS = 'PREVIOUS'
export const CURRENT = 'CURRENT'
